var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.2 882.2",
    style: {
      enableBackground: "new 0 0 882.2 882.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF0420;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 441.1,
    cy: 441.1,
    r: 440.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.6,558.1c-26.3,0-47.8-6.2-64.5-18.5c-16.6-12.5-24.9-30.5-24.9-53.6c0-4.9,0.5-10.8,1.6-17.8 c2.8-15.9,6.9-34.9,12.2-57.3c15-60.6,53.8-90.9,116.1-90.9c16.9,0,32.3,2.8,45.6,8.6c13.4,5.5,24,13.9,31.7,25.2 c7.8,11.1,11.6,24.3,11.6,39.7c0,4.6-0.5,10.4-1.6,17.4c-3.3,19.6-7.2,38.8-12,57.3c-7.8,30.1-21,52.9-40,67.9 C369.7,550.9,344.4,558.1,312.6,558.1z M317.4,510.5c12.3,0,22.7-3.7,31.4-10.9c8.8-7.2,15.2-18.3,18.9-33.5 c5.1-20.8,9-38.8,11.6-54.3c0.9-4.6,1.4-9.3,1.4-14.3c0-20.1-10.4-30.1-31.4-30.1c-12.3,0-22.9,3.7-31.7,10.9 c-8.6,7.2-14.8,18.3-18.5,33.5c-4.1,14.8-7.9,32.8-12,54.3c-0.9,4.4-1.4,9-1.4,13.9C285.5,500.5,296.2,510.5,317.4,510.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M457.5,555c-2.5,0-4.2-0.7-5.6-2.3c-1.1-1.8-1.4-3.7-1.1-6l45.6-215c0.4-2.5,1.6-4.4,3.7-6 c1.9-1.6,4.1-2.3,6.3-2.3h87.9c24.5,0,44.1,5.1,58.9,15.2c15,10.2,22.6,24.9,22.6,44.1c0,5.5-0.7,11.3-1.9,17.3 c-5.5,25.4-16.6,44.1-33.5,56.2c-16.6,12.2-39.3,18.2-68.2,18.2h-44.6l-15.2,72.4c-0.5,2.5-1.6,4.4-3.7,6c-1.9,1.6-4.1,2.3-6.3,2.3 H457.5z M574.5,428.6c9.3,0,17.3-2.5,24.1-7.6c7-5.1,11.6-12.3,13.9-21.9c0.7-3.7,1.1-7,1.1-9.9c0-6.3-1.9-11.3-5.6-14.6 c-3.7-3.5-10.2-5.3-19.2-5.3h-39.7l-12.5,59.2H574.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpIcon);
export default __webpack_public_path__ + "static/media/op_icon.e0638729e6bcdf3afe993e180e220fc3.svg";
export { ForwardRef as ReactComponent };